import { fetchRetry } from '@/utils/api/fetchRetry';

export async function getLeaguePlaysBySeason({ seasonId }, requestDocument = true) {
  try {
    const options = {
      url: `https://b5lrr2nc0h.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/${seasonId}`,
    };
    if (requestDocument) {
      options.url = `https://golstats-microservices.s3-us-west-2.amazonaws.com/statsLeagueBySeason-${seasonId}.json`;
      options.retries = 1;
    }
    const {
      data: { data },
    } = await fetchRetry(options);
    return data;
  } catch (e) {
    if (requestDocument) {
      return getLeaguePlaysBySeason({ seasonId }, false);
    }
    throw new Error(e);
  }
}

export async function getLeaguePlaysBySeasonMatchAnalysis({ seasonId }) {
  try {
    // https://iwxfzq6e2h.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/
    const response = await fetchRetry({
      url: `https://iwxfzq6e2h.execute-api.us-west-2.amazonaws.com/prod/v2/statisticsLeagueBySeason/${seasonId}`,
    });
    return response.data.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getLeaguePlaysBySeasonNextGames({ seasonId }) {
  try {
    const response = await fetchRetry({
      url: `https://o8h5khi564.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/${seasonId}`,
      // url: `https://b5lrr2nc0h.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/${seasonId}`,
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e);
  }
}

/**
 *
 * @param seasonId
 * @param requestDocument
 * @return {Promise<*>}
 */
/*export async function getLeagueStatisticsBySeason({ seasonId }, requestDocument = true) {
  try {
    const options = {
      url: `https://7a8s1p4177.execute-api.us-west-2.amazonaws.com/prod/statisticsGroupedBySeason/${seasonId}`
    }
    if (requestDocument) {
      options.url = `https://golstats-microservices.s3-us-west-2.amazonaws.com/statisticsGroupedBySeason-${seasonId}.json`;
      options.retries = 1;
    }
    const { data: { data } } = await fetchRetry(options)
    return data
  } catch (e) {
    if (requestDocument) {
      return getLeagueStatisticsBySeason({ seasonId }, false)
    }
    throw new Error(e);
  }
}*/

// export async function getLeagueStatisticsGroupedBySeason({ seasonId }, requestDocument = true) {
//   try {
//     const options = {
//       url: `https://30z5ngczs2.execute-api.us-west-2.amazonaws.com/prod/v2/statisticsGroupedBySeason/${seasonId}`,
//     };
//     if (requestDocument) {
//       options.url = `https://golstats-microservices.s3-us-west-2.amazonaws.com/statisticsGroupedBySeason-${seasonId}.json`;
//       options.retries = 1;
//     }
//     const {
//       data: { data },
//     } = await fetchRetry(options);
//     return data;
//   } catch (e) {
//     if (requestDocument) {
//       return getLeagueStatisticsGroupedBySeason({ seasonId }, false);
//     }
//     throw new Error(e);
//   }
// }

export async function getLeagueStatisticsGroupedBySeason({ seasonId }) {
  try {
    // v1 https://sqf4rkvoge.execute-api.us-west-2.amazonaws.com/prod/statisticsGroupedBySeason/
    const response = await fetchRetry({
      url: `https://sqf4rkvoge.execute-api.us-west-2.amazonaws.com/prod/v3/statisticsGroupedBySeason/${seasonId}`,
    });
    return response.data.data;
  } catch (e) {
    return Promise.reject(e);
  }
}
